import React from 'react';
import { useTranslation } from 'react-i18next'
import { createForm } from 'rc-form'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box';

import { formatNumber } from 'libraries/utils'

import vintageIcon from 'static/images/icons/vintage.svg'
import clockIcon from 'static/images/icons/clock.svg'
import foodIcon from 'static/images/icons/food.svg'
import temIcon from 'static/images/icons/tem.svg'

const WineAdvice = props => (
    <Grid item container alignItems="center" xs={props.width}>
        <img src={props.icon} alt="icon" />
        <Typography className="text-grey">{props.title}</Typography>
        <Typography variant="h2">{props.cont || '--'}</Typography>
    </Grid>
)

const WineAbout = props => (
    <Grid container className="wine-about">
        <Grid item xs={3}>
            <Typography>{props.title}</Typography>
        </Grid>
        <Grid item xs={9}>
            {props.children}
        </Grid>
    </Grid>
)

const WineAboutItem = props => (
    <Grid container className="about-item">
        <Grid item xs={3}>
            <Typography className="text-grey">{props.title}</Typography>
        </Grid>
        <Grid item xs={9}>
            <Typography>{props.cont}</Typography>
        </Grid>
    </Grid>
)

const WineDetailDialog = props => {
    const { t } = useTranslation();
    const { form, open, onClose, data } = props
    const { getFieldProps } = form

    const onSave = () => {
        props.form.validateFields((error, value) => {
            if (!error) {
                props.onSaveDrinkNote(value.comment)
            }
        })
    }
    
    return (
        <Dialog
            className="wine-detail"
            open={open}
            onClose={onClose}
            fullWidth
            scroll="paper"
        >
            <DialogTitle>
                <Grid container>
                    <Grid item xs={3}
                        className="wine-img"
                        style={{
                            backgroundImage: `url(${data.imageUrl})`,
                        }}
                    />
                    <Grid item container justify="space-between" xs={9}>
                        <Typography className="title">
                            {data.name}
                        </Typography>
                        <CloseIcon className="dialog-close pointer" onClick={onClose} />
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <Box className="wine-advice" bgcolor="rgba(74, 79, 85, 0.05)">
                    <Grid container alignItems="center">
                        <WineAdvice
                            width={5}
                            icon={temIcon}
                            title={t('serving_temp')}
                            cont={data.temperature}
                        />
                        <WineAdvice
                            width={7}
                            icon={clockIcon}
                            title={t('serving_time')}
                            cont={`${data.drinkingWindowsBeginYear || '--'} 年 - ${data.drinkingWindowsEndYear || '--'} 年`}
                        />
                        <WineAdvice
                            width={5}
                            icon={vintageIcon}
                            title={t('decanting_time')}
                            cont={data.decantMinute}
                        />
                        <WineAdvice
                            width={7}
                            icon={foodIcon}
                            title={t('food_pairing')}
                            cont={data.foodpairingName}
                        />
                    </Grid>
                </Box>
                <Grid container>
                    <WineAbout title={t('drink_note')}>
                        <TextField
                            margin="none"
                            name="cost"
                            id="comment"
                            variant="outlined"
                            fullWidth
                            multiline
                            rows={3}
                            inputProps={{
                                ...getFieldProps('comment', {
                                    initialValue: data.note,
                                })
                            }}
                        />
                    </WineAbout>
                    <WineAbout title={t('market_value')}>
                        <WineAboutItem
                            title={t('est_value')}
                            cont={`TWD ${formatNumber(data.value)}`}
                        />
                        <WineAboutItem
                            title={t('profit_and_loss')}
                            cont={`${data.profitAndLoss || '---'} %`}
                        />
                        <WineAboutItem
                            title={t('prediction')}
                            cont={data.perdiction}
                        />
                    </WineAbout>
                    <WineAbout title={t('wine_info')}>
                        <WineAboutItem
                            title={t('region')}
                            cont={data.region}
                        />
                        <WineAboutItem
                            title={t('winery')}
                            cont={data.winery}
                        />
                        <WineAboutItem
                            title={t('grape')}
                            cont={data.grape}
                        />
                        <WineAboutItem
                            title={t('vintage')}
                            cont={data.vintage}
                        />
                        <WineAboutItem
                            title={t('color')}
                            cont={data.color ? t(`${data.color}_wine`) : '--'}
                        />
                        <WineAboutItem
                            title={t('volume')}
                            cont={`${data.volume} ml`}
                        />
                    </WineAbout>
                </Grid>
            </DialogContent>
            <DialogActions className="dialog-func">
                <Grid container justify="flex-end" alignItems="center" style={{margin: '10px 22px'}}>
                    <Button color="primary" variant="contained" onClick={onSave}>
                        {t('save')}
                    </Button>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default createForm()(WineDetailDialog)